"use strict";

exports.__esModule = true;
var _AuthContext = require("./AuthContext");
Object.keys(_AuthContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AuthContext[key]) return;
  exports[key] = _AuthContext[key];
});
var _AuthController = require("./AuthController");
Object.keys(_AuthController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AuthController[key]) return;
  exports[key] = _AuthController[key];
});